import { render, staticRenderFns } from "./NotificationSecundary.vue?vue&type=template&id=eaad651c&scoped=true&"
import script from "./NotificationSecundary.vue?vue&type=script&lang=js&"
export * from "./NotificationSecundary.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSecundary.vue?vue&type=style&index=0&id=eaad651c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaad651c",
  null
  
)

export default component.exports